// Canvas v2 grouping. Project-scoped groups under
// `v2.groups = { [groupId]: { name, children: [pageKey…], collapsed } }`.

function makeGroupId() {
  return 'g_' + Math.random().toString(36).slice(2, 10)
}

export function group() {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const ids = v2.selection.ids
  if (ids.length < 2) return
  const id = makeGroupId()
  v2.groups = { ...(v2.groups || {}), [id]: { name: 'Group', children: [...ids], collapsed: false } }
  this.call('refreshCanvasChrome')
  this.call('persistCanvasLayout')
  this.call('syncCanvas')
}

export function ungroup(groupId) {
  const v2 = this.call('getCanvasV2'); if (!v2 || !groupId) return
  const next = { ...(v2.groups || {}) }
  delete next[groupId]
  v2.groups = next
  this.call('refreshCanvasChrome')
  this.call('persistCanvasLayout')
  this.call('syncCanvas')
}

export function collapseGroup(groupId) {
  const v2 = this.call('getCanvasV2')
  const g = v2?.groups?.[groupId]; if (!g) return
  g.collapsed = !g.collapsed
  this.call('syncCanvas')
}

// Re-exported alias of `bboxForGroup` from geom.js for callers using
// the old name.
export { bboxForGroup as groupBbox } from './geom.js'
